export const initialState = {
  basket: [],
  user: null
};

// Selector
export const getBasketTotal = (basket) => 
  basket?.reduce((amount, item) => item.price + amount, 0);

const reducer = (state, action) => {
  console.log(action);
  switch (action.type) {
    case 'ADD_TO_BASKET':
      // Corrected for adding a single item
      return {
        ...state,
        basket: [...state.basket, action.item],
      };
    
    case 'SET_BASKET':
      // New case for setting the entire basket
      return {
        ...state,
        basket: action.basket,
      };

    case 'EMPTY_BASKET':
      return {
        ...state,
        basket: []
      }

    case "REMOVE_FROM_BASKET":
      const index = state.basket.findIndex(
        (basketItem) => basketItem.id === action.id
      );
      let newBasket = [...state.basket];

      if (index >= 0) {
        newBasket.splice(index, 1);
      } else {
        console.warn(
          `Can't remove product (id: ${action.id}) as it's not in basket!`
        )
      }

      return {
        ...state,
        basket: newBasket
      }

    case "REMOVE_ALL_OF_ITEM":
      return {
        ...state,
        basket: state.basket.filter(
          (basketItem) => basketItem.id !== action.id
        )
      }
    
    case "SET_USER":
      return {
        ...state,
        user: action.user
      }

    default:
      return state;
  }
};

export default reducer;
